import React from "react";
import { FaEnvelopeOpenText } from "react-icons/fa";
import "./ContactHero.css";

const ContactHero = () => {
  return (
    <section className="_chSec_a1Z_"> 
      <div className="_chCont_b2Y_"> 
        <div className="_hIconW_c3X_"> 
          <FaEnvelopeOpenText className="_hIcon_d4W_" /> 
        </div>
        <h1 className="_hTitle_e5V_"> 
          Reach Out to <span className="_hTxt_f6U_">Vanidya</span>
        </h1>
        <p className="_hSubT_g7T_">
          Whether you're looking to partner, have questions, or simply want to
          learn more, we're here to connect. Fill out the form below or find our
          direct contact details.
        </p>
      </div>
    </section>
  );
};

export default ContactHero;